module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "data-table",
    style: (_vm.fixedExp)
  }, [_vm._t("default"), (!_vm.total && !_vm.loading) ? _c('tbody', [_c('tr', [_c('td', {
    staticClass: "noresult",
    attrs: {
      "id": "colspanNoData",
      "colspan": _vm.thAmount
    }
  }, [_vm._v("暂无数据")])])]) : _vm._e(), (_vm.loading && !_vm.list.length) ? _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "colspanLoading",
      "colspan": _vm.thAmount
    }
  }, [_c('img', {
    attrs: {
      "src": "//p.ssl.qhimg.com/t010aba4345b02168d6.gif"
    }
  })])])]) : _vm._e()], 2), (_vm.needpagination && _vm.ifPagination) ? _c('v-pagination', {
    attrs: {
      "total": _vm.total,
      "pn": _vm.pn,
      "ps": _vm.ps
    },
    on: {
      "updatepage": _vm.getPageData
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b4235f2e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b4235f2e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/data-table.vue
// module id = 793
// module chunks = 0